import script from "./FeaturedProductsSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./FeaturedProductsSection.vue?vue&type=script&setup=true&lang=ts"

import "./FeaturedProductsSection.vue?vue&type=style&index=0&id=5868a494&lang=css"

const __exports__ = script;

export default __exports__